import { dailyForecastArraySchema } from "@/schemas/daily-forecast-schema";
import { IFetchDailyForecastResult } from "@/types/daily-forecast-type";

const parseDate = (dateString: string) => {
	const day = Number(dateString.slice(0, 2));
	const month = Number(dateString.slice(2, 4)) - 1;
	const year = Number(dateString.slice(4, 8));

	return new Date(year, month, day);
};

const generateNext10Days = (): string[] => {
	return Array.from({ length: 10 }, (_, i) => {
		const date = new Date();
		date.setDate(date.getDate() + i);

		const day = String(date.getDate()).padStart(2, "0");
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const year = date.getFullYear();

		return `${day}${month}${year}`;
	});
};

export const fetchDailyMarine =
	async (): Promise<IFetchDailyForecastResult> => {
		const results = await Promise.all(
			generateNext10Days().map(async (item) => {
				try {
					const response = await fetch(
						`https://kuwait.exelys.io/kuwait_marine_daily_forecast/marine_stations_daily_forecast_${item}_030000+03:00.geojson`,
					);

					const data = await response.json();

					const validatedData = dailyForecastArraySchema.parse(data);

					return validatedData.map((forecast) => ({
						...forecast,
						date: parseDate(item),
					}));
				} catch {
					return [];
				}
			}),
		);

		return {
			isLoading: false,
			error: null,
			dayliesData: results.flat(),
		};
	};
